import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c72d05d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "y-units" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "y-unit" }, "0", -1))
const _hoisted_4 = { class: "x-units" }
const _hoisted_5 = { class: "base" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "alert-lines" }

import { PropType, ref, computed, nextTick } from 'vue'
import moment from 'moment'
import $ from 'jquery'
import { GraphPoint } from '@/components/rain_detail/GraphPanel.vue'
import Tooltip from '@/components/common/Tooltip.vue'
import { RESOLUTIONS, VIEW_MODES, ALERT_TYPE } from '@/lib/constants'
import SvgRect from '@/components/common/SVG/SvgRect.vue'
import { useGlobalStore } from '@/stores/globalStore'
import { Threshold } from '@/models/InitData'


export default /*#__PURE__*/_defineComponent({
  props: {
  datasets: {
    type: Array as PropType<GraphPoint[]>,
    default: () => [],
  },
  resolution: {
    type: String,
    default: RESOLUTIONS.HOURLY,
  },
  thresholds: {
    type: Array as PropType<Threshold[]>,
  },
},
  setup(__props) {

const props = __props

const MIN_Y = 6
const Y_UNITS = 6 // Y軸目盛りの数
const BASE_HEIGHT = 252

const showTooltip = ref<boolean>(false)
const currentPoint = ref<GraphPoint>()
const tooltipTop = ref<number>(0)
const tooltipLeft = ref<number>(0)


const globalStore = useGlobalStore()
const unitStyle = (index: number) => {
  const span = props.resolution === RESOLUTIONS.TEN_MIN ? 16.65 : 50
  const margin = props.resolution === RESOLUTIONS.TEN_MIN ? 11 : 30
  const left = index * span + margin

  return {
    left: `${left}px`,
  }
}
const maxY = computed(() => {
  const datasetMaxY = Math.max(...props.datasets.map(datum => datum.rainfall))
  const tmp = Math.max(datasetMaxY, MIN_Y)
  const mod = Y_UNITS - (tmp % Y_UNITS)

  return tmp + mod
})
const yUnits = computed(() => {
  const span = maxY.value / Y_UNITS

  return Array.from(Array(Y_UNITS))
    .map((_, index) => (index + 1) * span)
    .reverse()
})
const xUnitsLabelSpan = computed(() => (props.resolution === RESOLUTIONS.TEN_MIN ? 6 : 2))
const xUnits = computed(() => {
  const resolution =
    props.resolution === RESOLUTIONS.TEN_MIN ? 'minutes' : props.resolution === RESOLUTIONS.HOURLY ? 'hours' : 'days'
  const span = props.resolution === RESOLUTIONS.TEN_MIN ? 10 : 1
  const format = props.resolution === RESOLUTIONS.DAILY ? 'MM/DD' : 'HH:mm'
  const target = props.datasets[xUnitsLabelSpan.value - 1]

  if (!target) {
    return []
  }

  const time = moment(target.statusTime)
  const now = moment(time)

  return Array.from(Array(7)).map((_, index) => {
    return moment(now)
      .add(span * xUnitsLabelSpan.value * index, resolution)
      .format(format)
  })
})
const fillColor = computed(() => {
  return globalStore.systemViewmode === VIEW_MODES.DARK ? '#c8ffff' : '#0076c8'
})
const width = computed(() => {
  return props.resolution === RESOLUTIONS.TEN_MIN ? 12 : 40
})
const alertStyle = (type: string) => {
  let threshold

  if (!props.thresholds) {
    return { display: 'none' }
  }

  const thresholds = props.thresholds

  if (type === 'warning') {
    threshold = thresholds.find(t => t.status === 'warn_1')
  } else if (type === 'alert') {
    threshold = thresholds.find(t => t.status === 'warn_2')
  } else if (type === 'special') {
    threshold = thresholds.find(t => t.status === 'warn_3')
  }

  if (!threshold) {
    return { display: 'none' }
  }

  const y = convertY(threshold.comparison)

  if (y > 250) {
    return { display: 'none' }
  }

  return {
    bottom: `${y}px`,
  }
}
const convertY = (value: number) => {
  return value * (BASE_HEIGHT / maxY.value)
}

const currentValue = computed(() => {
  return currentPoint.value?.rainfall
})

const currentDate = computed(() => {
  const format = props.resolution === 'daily' ? 'MM/DD' : 'HH:mm'

  return moment(currentPoint.value?.statusTime).format(format)
})

const handleMouseover = (point: GraphPoint, e: MouseEvent) => {
  const offset = $('.base').offset() || {}
  const x = e.pageX - (offset.left || 0)
  const y = e.pageY - (offset.top || 0) - 50 // ツールチップ見えやすいように位置調整

  currentPoint.value = point
  nextTick(() => {
    showTooltip.value = true
    tooltipTop.value = y - 50
    tooltipLeft.value = x + 30
  })
}
const handleMouseleave = () => {
  showTooltip.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yUnits), (unit, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "y-unit"
        }, _toDisplayString(unit), 1))
      }), 128)),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(xUnits), (unit, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "x-unit"
        }, _toDisplayString(unit), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createVNode(Tooltip, {
        top: tooltipTop.value,
        left: tooltipLeft.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(currentDate)), 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_unref(currentValue)?.toFixed(1)) + "mm ", 1)
        ]),
        _: 1
      }, 8, ["top", "left"]), [
        [_vShow, showTooltip.value]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          style: _normalizeStyle(alertStyle(_unref(ALERT_TYPE).WARNING)),
          class: "alert-lines-line warning"
        }, null, 4),
        _createElementVNode("div", {
          style: _normalizeStyle(alertStyle(_unref(ALERT_TYPE).ALERT)),
          class: "alert-lines-line alert"
        }, null, 4),
        _createElementVNode("div", {
          style: _normalizeStyle(alertStyle(_unref(ALERT_TYPE).SPECIAL)),
          class: "alert-lines-line special"
        }, null, 4)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.datasets, (datum, index) => {
        return (_openBlock(), _createBlock(SvgRect, {
          onMouseover: ($event: any) => (handleMouseover(datum, $event)),
          onMouseleave: handleMouseleave,
          style: _normalizeStyle(unitStyle(index)),
          key: index,
          width: _unref(width),
          height: convertY(datum.rainfall),
          value: datum.rainfall,
          fill: _unref(fillColor)
        }, null, 8, ["onMouseover", "style", "width", "height", "value", "fill"]))
      }), 128))
    ])
  ]))
}
}

})